import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import {
    AuthenticationService,
    MenuNavigationService,
    User,
    UserProvider,
} from '@siat-fe/auth';
import {
    CustomModalOptions,
    ModalType,
    SmartModalAction,
    SmartModalService,
} from '@siat-fe/shared';
import { filter, Observable, switchMap, take, tap } from 'rxjs';
@Component({
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    MatToolbarModule,
    MatMenuModule,
    MatTooltipModule,
  ],
   
  selector: 'siat-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  userLogged$: Observable<User | null>;

  /**
   * The service used to open smart modals.
   */
  smartModalService = inject(SmartModalService);

  /**
   * The service used to navigate between menu items.
   */
  menuNavigationService = inject(MenuNavigationService);

  /**
   * It streams the current app menu items.
   */
  currentAppMenuItems$ = this.menuNavigationService.currentAppMenuItems$;

  /**
   * It streams all available apps.
   */
  availableAppIds$ = this.menuNavigationService.availableAppIds$;

  /**
   * The current app ID
   */
  currentAppId: string | null = null;

  /**
   * The router service.
   */
  readonly router = inject(Router);

  userProvider = inject(UserProvider);
  authService = inject(AuthenticationService);

  constructor() {
    this.userLogged$ = this.userProvider.currentUser$;
  }

  /**
   * @inheritdoc
   */
  ngOnInit(): void {
    this.menuNavigationService.selectedAppId$
      .pipe(take(1))
      .subscribe(id => (this.currentAppId = id));
  }

  /**
   * Logout the user.
   */
  logout(): void {
    const modalOptions = {
      title: 'Attenzione',
      message: 'Sei sicuro di voler uscire?',
      config: {
        disableClose: true,
      },
    } as CustomModalOptions;

    this.smartModalService
      .openSmartModal(ModalType.CONFIRM, modalOptions)
      .pipe(
        take(1),
        filter(
          (action: SmartModalAction) => action === SmartModalAction.CONFIRMED
        ),
        switchMap(() =>
          this.authService
            .logout()
            .pipe(tap(() => this.router.navigate(['/logout'])))
        )
      )
      .subscribe();
  }

  /**
   * Navigates to the select app page.
   */
  goToSelectApp(isActive: boolean, appId?: string): void {
    if (isActive) return;
    const modalOptions = {
      title: 'Attenzione',
      message: 'Sei sicuro di voler lasciare la pagina?',
    } as CustomModalOptions;

    this.smartModalService
      .openSmartModal(ModalType.CONFIRM, modalOptions)
      .pipe(
        filter(
          (action: SmartModalAction) => action === SmartModalAction.CONFIRMED
        ),
        tap(() => this.router.navigate([appId]))
      )
      .subscribe();
  }

  /**
   * @returns true if items is active
   */
  isItemActive(id: string | null, app: string): boolean {
    return id === app;
  }
}
